module.exports = __webpack_public_path__ + "fonts/icomoon.9262229f.woff";